/**************
 Mobile Nav
 ***************/

// mobile slider nested dropdown
document.querySelectorAll(".sliderNavDropdownToggle").forEach(element => {
    element.addEventListener("click", function () {
        this.classList.toggle("active");
        this.setAttribute("aria-expanded", this.classList.contains("active"));
    });
});

// open nav
function openNav() {
    document.querySelector("#slider").showModal();
    document.querySelector("body").classList.add("noScroll");
}

// dialog close event, the bag link opens the cart as the nav closes so leave its scroll lock alone
document.querySelector("#slider").addEventListener("close", function () {
    if (document.querySelector("#miniCart").open) {
        return;
    }
    document.querySelector("body").classList.remove("noScroll");
});

// close nav
function closeNav() {
    document.querySelector("#slider").close();
}

// open nav event listener
document.querySelectorAll(".openNav").forEach(function (element) {
    element.addEventListener("click", openNav);
});

// the search and bag links open over the page, so the nav gets out of the way
document.querySelector("#sliderSearch").addEventListener("click", closeNav);
document.querySelector("#sliderLinksBag").addEventListener("click", closeNav);

// close nav event listener
document.querySelectorAll(".closeNav").forEach(function (element) {
    element.addEventListener("click", closeNav);
});

/**************
 Search
 ***************/

// open/close search from any search trigger
document.querySelectorAll(".openSearch").forEach(function (element) {
    element.addEventListener("click", function () {
        document.querySelector("#headerSearch").classList.toggle("active");
        document.querySelector("#searchExit").classList.toggle("active");

        // focus the input when the search opens
        if (document.querySelector("#headerSearch").classList.contains("active")) {
            document.querySelector("#headerSearchBarFormInput").focus();
        }
    });
});

// close search on the close button
document.querySelector("#headerSearchBarClose").addEventListener("click", function () {
    document.querySelector("#headerSearch").classList.remove("active");
    document.querySelector("#searchExit").classList.remove("active");
});

// close search when the backdrop is clicked
document.querySelector("#searchExit").addEventListener("click", function () {
    this.classList.remove("active");
    document.querySelector("#headerSearch").classList.remove("active");
});

// the theme-header section id drives the predictive search render
const headerSectionId = document.querySelector("#header").dataset.sectionId;

// our own search endpoint, used instead of shopify's suggestions when ready to ship is checked
const FILTERED_SEARCH_URL = "https://api.audryrosejewelry.com/public/filtered-search.php";

// the dropdown only has room for a short list
const FILTERED_SEARCH_LIMIT = 10;

// wait for a pause in typing so a search fires once per word, not once per keystroke
const SEARCH_DEBOUNCE_MS = 250;
let searchDebounce = null;

// every search claims an id so a slow response can't paint over a newer one
let searchRequestID = 0;

// pull suggestions from shopify and return its rendered markup
async function predictiveSearch(searchTerm) {
    const text = await fetch(window.Shopify.routes.root + `search/suggest?q=${encodeURIComponent(searchTerm)}&resources[type]=product,collection&section_id=${headerSectionId}`)
        .then(response => response.text())
        .catch(e => {
            console.error(e);
        });

    if (!text) {
        return null;
    }

    // parse the rendered section markup so we can pull the results out
    const html = document.createElement("div");
    html.innerHTML = text;

    const searchHTML = html.querySelector("#headerSearchBody");
    if (!searchHTML || !searchHTML.innerHTML.trim().length) {
        return null;
    }

    return searchHTML.innerHTML;
}

// build the suggestion markup ourselves since our api returns json, not rendered liquid
function renderFilteredSearch(products) {
    // fall back to the same empty state the section renders
    let suggestionHTML = `<div class="headerSearchBodySuggestionEmpty">No Results</div>`;

    // group the matches under a products heading
    if (products.length) {
        let productsHTML = "";
        products.forEach(product => {
            productsHTML += `<a class="headerSearchBodySuggestionGroupItem" href="${product.url}">${product.title}</a>`;
        });

        suggestionHTML = `
            <div class="headerSearchBodySuggestionGroup">
                <div class="headerSearchBodySuggestionGroupTitle">Products</div>
                ${productsHTML}
            </div>
        `;
    }

    return `
        <div id="headerSearchBodySuggestion">
            ${suggestionHTML}
        </div>
    `;
}

// pull suggestions from our own api so results can be limited to ready to ship
async function filteredSearch(searchTerm) {
    // nothing typed yet, so clear the results rather than showing a stale list
    if (!searchTerm.length) {
        return `<div id="headerSearchBodySuggestion"></div>`;
    }

    const response = await fetch(FILTERED_SEARCH_URL, {
        method: "POST",
        body: JSON.stringify({query: searchTerm, limit: FILTERED_SEARCH_LIMIT}),
    })
        .then(response => response.json())
        .catch(e => {
            console.error(e);
        });

    if (!response || response.error) {
        return null;
    }

    return renderFilteredSearch(response.products || []);
}

// run whichever search matches the current ready to ship state
async function runHeaderSearch() {
    const searchTerm = document.querySelector("#headerSearchBarFormInput").value.trim();

    // claim this run so we can tell later whether it is still the newest one
    searchRequestID++;
    const requestID = searchRequestID;

    let bodyHTML = null;
    if (document.querySelector("#headerSearchReadyInput").checked) {
        bodyHTML = await filteredSearch(searchTerm);
    } else {
        bodyHTML = await predictiveSearch(searchTerm);
    }

    // another search started while this one was in flight, so drop its results
    if (requestID !== searchRequestID) {
        return;
    }

    // the search failed or had nothing to show, so leave what's on screen alone
    if (bodyHTML === null) {
        return;
    }

    document.querySelector("#headerSearchBody").innerHTML = bodyHTML;
}

// hold off until typing pauses so we aren't firing a request per character
function debounceHeaderSearch() {
    clearTimeout(searchDebounce);
    searchDebounce = setTimeout(runHeaderSearch, SEARCH_DEBOUNCE_MS);
}

// listen for predictive search
document.querySelector("#headerSearchBarFormInput").addEventListener("input", debounceHeaderSearch);

// re-run the search so toggling the filter updates the results already on screen
document.querySelector("#headerSearchReadyInput").addEventListener("change", runHeaderSearch);

// submit the full search reading the input at submit time, so Enter and the magnifying-glass button always carry the complete term
document.querySelector("#headerSearchBarForm").addEventListener("submit", function (e) {
    e.preventDefault();
    const searchTerm = document.querySelector("#headerSearchBarFormInput").value.trim();

    // carry the filter through to the search page so it opens on the same results
    let readyParam = "";
    if (document.querySelector("#headerSearchReadyInput").checked) {
        readyParam = "&ready=1";
    }

    window.location.href = window.Shopify.routes.root + `search?type=product,collection&q=${encodeURIComponent(searchTerm)}${readyParam}`;
});
